import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {AdvancedGamesFilterFooterDefaultBox} from "./advanced-games-filter-footer.default";
import {AdvancedGamesFilterFooterMrGreenBox} from "./advanced-games-filter-footer.mrgreen";
import {AdvancedGamesFilterFooterSiBox} from "./advanced-games-filter-footer.si";

export const AdvancedGamesFilterFooterBox = styledByTheme(AdvancedGamesFilterFooterDefaultBox)
    .forSI(AdvancedGamesFilterFooterSiBox)
    .forSICis(AdvancedGamesFilterFooterSiBox)
    .forMrGreen(AdvancedGamesFilterFooterMrGreenBox)
    .forMrGreenCis(AdvancedGamesFilterFooterMrGreenBox).apply();
